import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';

export class Step761548Meta extends BaseModel {
  deceasedFullName: string | null;
  executorFullName: string | null;

  constructor(model: Partial<Step761548Meta> = {}) {
    super();

    this.deceasedFullName = model.deceasedFullName ?? null;
    this.executorFullName = model.executorFullName ?? null;
  }
}
